/**
 * Online store, session C — the shop runs its website from the till: the
 * settings card, the „საიტზე" switch on a product or model, a category at
 * once (migration 153). The address and on/off are MartePOS's (the platform
 * console, Georgian only), never these screens'.
 */
export const site = {
  'set.store.title': 'ონლაინ მაღაზია',
  'set.store.sub': 'შენი საიტი — რა ჩანს, მიტანა, სახე',
  'set.store.on': 'საიტი ჩართულია',
  'set.store.off': 'საიტი გამორთულია — ჩართვას MartePOS აკეთებს',
  'set.store.open': 'საიტის ნახვა',
  'set.store.addressNote': 'მისამართს და ჩართვა-გამორთვას MartePOS მართავს',
  'set.store.listing': 'რომელი პროდუქტი ჩანს საიტზე',
  'set.store.auto': 'ავტომატურად',
  'set.store.autoHint': 'ყველა, რასაც ფოტო და ფასი აქვს. ცალკეულს „საიტზე" ჩამრთველით მოხსნი.',
  'set.store.manual': 'ხელით',
  'set.store.manualHint': 'მხოლოდ ის, რასაც თავად ჩართავ — პროდუქტზე, მოდელზე ან მთელ კატეგორიაზე.',
  'set.store.count': 'საიტზე გამოჩნდება: {n}',
  'set.store.f.listing': 'რეჟიმი',
  'set.store.f.tagline': 'სლოგანი',
  'set.store.taglinePh': 'მაგ. ახალი კოლექცია ყოველ კვირას',
  'set.store.f.hero': 'მთავარი ფოტო',
  'set.store.heroUpload': 'ფოტოს ატვირთვა',
  'set.store.heroRemove': 'მოშორება',
  'set.store.f.phone': 'საიტის ტელეფონი',
  'set.store.phonePh': 'ცარიელი — კომპანიის ტელეფონი',
  'set.store.f.fee': 'მიტანის ფასი',
  'set.store.feePh': 'ცარიელი — მიტანა არ არის',
  'set.store.freeFrom': 'უფასო მიტანა, თანხიდან',
  'set.store.freeFromPh': 'ცარიელი — ყოველთვის ფასიანი',
  'set.store.pickupOn': 'მაღაზიიდან წაღებაც ჩანს — {address}',
  'set.store.pickupOff': 'მაღაზიიდან წაღება არ ჩანს: კომპანიის მისამართი ცარიელია (პარამეტრები → კომპანია)',
  'set.store.save': 'შენახვა',
  'set.store.saved': 'საიტი შენახულია',
  'set.store.err.save': 'საიტი ვერ შეინახა',
  'set.store.err.invalid': 'შეამოწმე: {field}',
  'set.store.uploadFailed': 'ფოტო ვერ აიტვირთა',

  'wh.online.title': 'საიტზე',
  'wh.online.hintManual': 'ჩართე — პროდუქტი შენს საიტზე გამოჩნდება',
  'wh.online.hintAuto': 'საიტზე ავტომატურად ჩანს — გამორთე, თუ არ გინდა',
  'wh.online.shown': 'საიტზე ჩანს',
  'wh.online.why.off': 'საიტზე არ ჩანს',
  'wh.online.why.hidden': 'საიტიდან დამალულია',
  'wh.online.why.noPhoto': 'არ ჩანს — ფოტო არ აქვს',
  'wh.online.why.noPrice': 'არ ჩანს — ფასი არ აქვს',
  'wh.online.part': '{of} ზომიდან ჩართულია {n} — ჩამრთველი ყველას ერთნაირად აყენებს',
  'wh.online.bulk': 'საიტი — კატეგორია',
  'wh.online.bulkShort': 'საიტი',
  'wh.online.bulkTitle': 'საიტი — მთელი კატეგორია',
  'wh.online.bulkHint': 'კატეგორია ქვეკატეგორიებთან ერთად. ცალკეულ პროდუქტს მერეც შეცვლი მის ფანჯარაში.',
  'wh.online.category': 'კატეგორია',
  'wh.online.pick': 'აირჩიე კატეგორია',
  'wh.online.on': 'ჩართე ფოტოიანები',
  'wh.online.offAll': 'გამორთე ყველა',
  'wh.online.hide': 'დამალე ყველა',
  'wh.online.unhide': 'გამოაჩინე ყველა',
  'wh.online.done': 'შეიცვალა: {n}',
  'wh.online.none': 'შესაცვლელი არაფერი იყო',
  'wh.online.modeChanged': 'საიტის რეჟიმი სხვა მოწყობილობაზე შეიცვალა — ღილაკები განახლდა, აირჩიე თავიდან',
} as const
